import { render, staticRenderFns } from "./StakedStepper.vue?vue&type=template&id=82b51b64"
import script from "./StakedStepper.vue?vue&type=script&lang=js"
export * from "./StakedStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports